import { FC } from 'react';

import MandatoryField from '../MandatoryField';
import IconTooltip from '../Icon/IconTooltip';

type InputCheckboxProps = {
  id: string;
  checked: boolean;
  label: string;
  onChange: () => void;
  required?: boolean;
  lgSize?: boolean;
  disabled?: boolean;
  marginBottom?: number;
  readOnly?: boolean;
  tooltip?: string;
};

const InputCheckbox: FC<InputCheckboxProps> = ({
  id,
  checked,
  label,
  onChange,
  required = false,
  disabled = false,
  marginBottom,
  readOnly = false,
  tooltip,
}) => {
  const InputComponent = (
    <input
      type="checkbox"
      className="custom-control-input"
      id={id}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      readOnly={readOnly}
    />
  );

  return (
    <div
      className={`custom-control custom-checkbox ${
        marginBottom !== undefined ? `mb-${marginBottom}` : ''
      }`}
    >
      {InputComponent}
      {label && (
        <label className="custom-control-label" htmlFor={id}>
          {label}{' '}
          {required && (
            <span className="ml-1">
              <MandatoryField />
            </span>
          )}
          {tooltip && (
            <IconTooltip id={`${id}-tooltip`} tooltip={tooltip} place="right" />
          )}
        </label>
      )}
    </div>
  );
};

export default InputCheckbox;
